import type { SxProps, Theme } from "@/common/styles/style";

export const styles = {
  container: {
    height: "80vh",
  },

  title: {
    margin: "1rem 0",
  },

  content: {
    width: "100%",
  },

  label: {
    marginBottom: 1,
    fontWeight: 600,
  },

  dialogPaper: {
    width: "500px",
    maxWidth: "calc(100vw - 48px)",
  },

  radioGroup: {
    marginBottom: 2,
  },

  templateTableWrapper: {
  width: "100%",
  marginBottom: 2,
},

  templateName: {
    width: "100%",
    marginBottom: 2,
  },

  uploadArea: {
    width: "100%",
    minHeight: "90px",
    boxSizing: "border-box",

    border: "1px dashed",
    borderColor: "divider",
    borderRadius: 1,

    cursor: "pointer",
    marginBottom: 2,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "&:hover": {
      backgroundColor: "action.hover",
    },
  },

  uploadAreaDragOver: {
    backgroundColor: "action.selected",
  },

  uploadContent: {
    width: "100%",
    minWidth: 0,
    minHeight: "90px",

    padding: 2,
    boxSizing: "border-box",

    textAlign: "center",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  fileIcon: {
    fontSize: "2rem",
  },

  uploadedFileIcon: {
    fontSize: "2rem",
    color: "success.main",
  },

  uploadDescription: {
    color: "text.secondary",
  },

  fileName: {
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,

    fontWeight: 600,

    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  buttonArea: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },

  cancelButton: {
    minWidth: "104px",
  },

  registerButton: {
    minWidth: "104px",
  },
} satisfies Record<string, SxProps<Theme>>;